import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  ShopCompanyPayload,
  ShopCompanyUpdatePayload,
} from 'src/app/components/shop-companies/shop-company.models';

@Injectable({
  providedIn: 'root',
})
export class LambdaService {
  [x: string]: any;
  private apiKey = environment.apiKey;
  baseURL = environment.apiGatewayUrl;
  // s3Instance: any;

  private baseConfig = `{"credentials":"same-origin","headers":{"Accept":"application/json","Content-Type":"application/json","Authorization":"${this.apiKey}"},"method":""}`;


  constructor(private injector: Injector) {
    // this.createS3Instance();
  }

  //---------------------BASE METHODS--------------------
  async simpleGet(url: string) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'GET';
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async simplePost(url: string, body: any) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'POST';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async simplePut(url: string, body: any) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'PUT';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Authorized (authentication required methods)

  async authorizedPut(url: string, body: any) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'PUT';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async authorizedDelete(url: string, body: any) {
    // Change this method !!!!!!!!!!
    let config = JSON.parse(this.baseConfig);
    config.method = 'DELETE';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  //-------------------SPECIFIC REQUEST METHODS------------------

  async getClientSessions(
    shopId: number,
  ) {
    let url = `/timekit/clientSessions?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getSeoSettings(shopId: number) {
    let url = `/seo?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCashRegisterMovements(shopId: number, cashRegisterId: number) {
    let url = `/cashRegister/movements/${cashRegisterId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  uploadProducts(
    data: object
  ) {
    let url = '/products/upload';
    let body = data;
    return this.simplePost(url, JSON.stringify(body));
  }

  async getSales(
    shopId: number,
    searchString: string,
    counter: number,
    amount: number,
    startDate: string,
    endDate: string,
    paymentTypeId: string,
    saleState: number | null,
    shopPointId: string
  ) {
    let url = `/sales?shopId=${shopId}&searchString=${searchString}&counter=${counter}&amount=${amount}&startDate=${startDate}&endDate=${endDate}&paymentTypeId=${paymentTypeId}&saleState=${saleState}&shopPointId=${shopPointId}`;
    return this.simpleGet(url);
  }

  async getSale(saleId: number, shopId: number) {
    return this.simpleGet(`/sales/${saleId}?shopId=${shopId}`);
  }

  async getProducts(
    shopId: number,
    counter: number,
    amount: number,
    searchString: string,
    isActive: string,
    creationDateSort: string,
    quantitySort: string
  ) {
    let url = `/products?shopId=${shopId}&counter=${counter}&amount=${amount}&searchString=${searchString}&isActive=${isActive}&creationDateSort=${creationDateSort}&quantitySort=${quantitySort}`;
    return this.simpleGet(url);
  }
  /**
   * Obtiene productos filtrados usando GET.
   * Todos los filtros van en la query-string.
   */
  async getFilteredProducts(filters: any): Promise<any> {

    const qs = new URLSearchParams();

    /* obligatorios */
    qs.append('shopId', String(filters.shopId));
    qs.append('counter', String(filters.counter ?? 0));
    qs.append('amount', String(filters.amount ?? 25));

    /* opcionales */
    if (filters.search) qs.append('search', filters.search);
    if (filters.onlyActive !== undefined)
      qs.append('onlyActive', filters.onlyActive ? '1' : '0');
    if (filters.categoryId) qs.append('categoryId', String(filters.categoryId));
    if (filters.subCategoryId) qs.append('subCategoryId', String(filters.subCategoryId));
    if (filters.subSubCategoryId) qs.append('subSubCategoryId', String(filters.subSubCategoryId));
    if (filters.collectionId) qs.append('collectionId', String(filters.collectionId));
    if (filters.supplierId) qs.append('supplierId', String(filters.supplierId));

    const url = `/products/filtered?${qs.toString()}`;

    /* simpleGet espera solo la URL */
    return this.simpleGet(url);
  }

  async getUsersAndBeneficiaries(
    shopId: number
  ) {
    let url = `/users/with-beneficiaries?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  getSaleLogs(
    shopId: number, 
    filter: any, 
    currentPage: number, 
    pageSize: number
  ) {
    // Construir URL con parámetros base
    let url = `/logs/sale?shopId=${shopId}&currentPage=${currentPage}&pageSize=${pageSize}`;
    // Agregar filtros opcionales si existen
    if (filter) {
      if (filter.logType) {
        url += `&logType=${filter.logType}`;
      }
      if (filter.startDate) {
        url += `&startDate=${filter.startDate}`;
      }
      if (filter.endDate) {
        url += `&endDate=${filter.endDate}`;
      }
      if (filter.search) {
        url += `&search=${filter.search}`;
      }
    }
    return this.simpleGet(url);
  }

  async getClients(
    shopId: number,
    searchString: string,
    counter: number,
    amount: number,
    order: string) {
    let url = `/users?shopId=${shopId}&counter=${counter}&amount=${amount}&searchString=${searchString}&order=${order}`;
    return this.simpleGet(url);
  }

  async getClient(
    shopId: number,
    clientId: number
  ) {
    let url = `/users/${clientId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getShopCompanies(shopId: number, activeOnly: boolean = false) {
    let url = `/shopcompanies?shopId=${shopId}`;
    if (activeOnly) {
      url += '&status=1';
    }
    return this.simpleGet(url);
  }

  async getShopCompanyById(shopId: number, shopCompanyId: number) {
    return this.simpleGet(
      `/shopcompanies/${shopCompanyId}?shopId=${shopId}`
    );
  }

  createShopCompany(shopId: number, payload: ShopCompanyPayload) {
    return this.simplePost(
      `/shopcompanies/create?shopId=${shopId}`,
      JSON.stringify(payload)
    );
  }

  updateShopCompany(
    shopId: number,
    shopCompanyId: number,
    payload: ShopCompanyUpdatePayload
  ) {
    return this.simplePut(
      `/shopcompanies/${shopCompanyId}?shopId=${shopId}`,
      JSON.stringify({ ...payload, shopCompanyId })
    );
  }

  deleteShopCompany(shopId: number, shopCompanyId: number) {
    return this.simplePost(
      `/shopcompanies/delete?shopId=${shopId}`,
      JSON.stringify({ shopCompanyId })
    );
  }

  async getClientByNationalId(
    shopId: number,
    clientNationalId: string
  ) {
    let url = `/user?shopId=${shopId}&searchNationalId=${clientNationalId}`;
    return this.simpleGet(url);
  }

  async getClientSales(
    clientId: string | number,
    counter: number,
    amount: number,
    searchString: string,
    shopId: number) {
    return this.simpleGet(`/users/orders?clientId=${clientId}&counter=${counter}&amount=${amount}&searchString=${searchString}&shopId=${shopId}`);
  }

  async getUserSaleById(saleId: number, shopId: number) {
    return this.simpleGet(`/orders/${saleId}?shopId=${shopId}`);
  }

  async getCashRegisters(shopId: number) {
    let url = `/cashRegister?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getShopPoints(shopId: number) {
    let url = `/shoppoints?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getShopPointById(shopPointId: number, shopId: number) {
    let url = `/shoppoints/${shopPointId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getDailySales(
    shopId: number,
    channel: number,
    startDate: string,
    endDate: string
  ) {
    let url = `/sales/daily?shopId=${shopId}&channel=${channel}&startDate=${startDate}&endDate=${endDate}`;
    return this.simpleGet(url);
  }

  async getTaxes(idShop: number) {
    let url = `/taxes?shopId=${idShop}`;
    return this.simpleGet(url);
  }

  async getCoupons(
    shopId: number,
    counter: number,
    amount: number,
    searchString: string
  ) {
    let url = `/coupons?shopId=${shopId}&counter=${counter}&amount=${amount}&searchString=${searchString}`;
    return this.simpleGet(url);
  }

  async getGiftCardTypes(shopId: number) {
    let url = `/giftCardTypes?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getGiftCardTypesById(shopId: number, giftCardTypeId: number) {
    let url = `/giftCardTypes/${giftCardTypeId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getGiftCardItems(shopId: number) {
    let url = `/giftCards?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getGiftCardItemsById(giftCardId: number, shopId: number) {
    let url = `/giftCards/${giftCardId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCashRegisterById(cashRegisterId: number, shopId: number) {
    let url = `/cashRegister/${cashRegisterId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCoupon(idCoupon: number, shopId: number) {
    let url = `/coupons/${idCoupon}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCouponUsage(idCoupon: number, shopId: number) {
    let url = `/coupons/usage/${idCoupon}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getPaymentMethods(shopId: number) {
    let url = `/payments?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getPaymentMethodById(shopId: number, paymentId: number) {
    let url = `/payments/${paymentId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getPaymentById(paymentTypeId: number, shopId: number) {
    let url = `/payments/${paymentTypeId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getProductById(productId: number, shopId: number) {
    return this.simpleGet(`/products/${productId}?shopId=${shopId}`);
  }

  async getSuppliers(shopId: number) {
    let url = `/suppliers?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getSupplierReportData(shopId: number, supplierId: number) {
    let url = `/suppliers/report?shopId=${shopId}&supplierId=${supplierId}`;
    return this.simpleGet(url);
  }

  async getIndustries() {
    let url = `/industries?`;
    return this.simpleGet(url);
  }

  getShopData(shopId: number) {
    let url = `/shop?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  getShippingCosts(shopId: number) {
    let url = `/shippingCosts?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  getCountries() {
    let url = `/shop/location?geoLocationType=0&geoLocationId=0`;
    return this.simpleGet(url);
  }

  async getThemingService(shopGuid: string) {
    let url = `/theme?shopGuid=${shopGuid}`;
    return this.simpleGet(url);
  }

  async getShopsByIds(shops: string) {
    let url = `/login?shops=${shops}`;
    return this.simpleGet(url);
  }

  async getBlockHoursAndDays(shopId: number) {
    let url = `shop/calendarBlocks/${shopId}`;
    return this.simpleGet(url);
  }

  async unlockDates(shopId: number, externalId: string, start_datetime: string, end_datetime: string) {
    let url = `/timekit/unblock`;
    let body = {
      shopId,
      externalId,
      start_datetime,
      end_datetime,
      action: "unblockHours"
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  async getTimekitResources(shopId: number) {
    let url = `/timekit/resources?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getTimekitProjects(shopId: number) {
    let url = `/timekit/projects?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  /* TRAER CITAS - SESIONES YA AGENDADAS PARA MOSTRARLAS */
  async getAvailability(shopId: number, projectId: string) {
    let url = `/timekit/availability?shopId=${shopId}&projectId=${projectId}`;
    return this.simpleGet(url);
  }

  /* TRAER CITAS - SESIONES DISPONIBLES PARA AGENDAR */
  async getBookings(shopId: number, projectId: string) {
    let url = `/timekit/bookings`;
    let body = {
      shopId,
      projectId,
      action: "bookings"
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  /* REAGENDAR CITAS - SESIONES */
  async rescheduleBookings(shopId: number, projectId: string, resourceId: string, bookingId: string, start: string, end: string) {
    let url = `/timekit/bookings`;
    let body = {
      shopId,
      projectId,
      resource_id: resourceId,
      bookingId,
      start: start,
      end: end,
      action: 'reschedule'
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  /* CANCELAR */
  cancelBooking(shopId: number, projectId: string, bookingId: string) {
    let url = `/timekit/bookings?shopId=${shopId}&projectId=${projectId}`;
    let body = {
      bookingId,
      action: 'cancelBooking'
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  /* ACTUALIZAR HORARIO */
  updateAvailability(shopId: number, projectId: string, formattedConstraints: any) {
    let url = `/timekit/schedule?shopId=${shopId}&projectId=${projectId}`;
    let body = {
      action: 'updateAvailability',
      availability_constraints: formattedConstraints
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  /* CREAR CITA */
  async createBookings(shopId: number, resourceId: string, projectId: string, start: string, end: string, customer: { name: string; email: string; clientId: string, phone: number }, what: string, where: string) {
    let url = `/timekit/schedule`;
    let body = {
      shopId,
      resourceId,
      projectId,
      start,
      end,
      customer,
      what,
      where,
      action: 'CreateBooking'
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  async createBookingSessions(shopId: number, clientId: number, projectId: number, sessionId: string) {
    let url = `/timekit/sessions`;
    let body = {
      shopId,
      projectId,
      clientId,
      sessionId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deleteSessions(shopId: number, sessionId: string) {
    const url = '/timekit/sessions/delete';
    const body = {
      shopId,
      sessionId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createBeneficiaries(
    shopId: number,
    beneficiaryName: string,
    beneficiaryNationalId: number,
    beneficiaryBornDate: number,
    beneficiaryGender: string,
    beneficiaryPhone: number,
    beneficiaryEmail: string,
    nationalId: number,
    beneficiaryLastName: string,
    beneficiaryRelationship: string,
    beneficiaryBreed: string,
    beneficiaryColor: string,
    beneficiaryDocumentType: string,
    beneficiaryRegionId: string,
    beneficiaryAddress: string,
    beneficiaryProvince: string,
    beneficiaryCounty: string,
    beneficiaryDistrict: string
  ) {
    let url = `/beneficiaries/create`;
    let body = {
      shopId,
      beneficiaryName,
      beneficiaryNationalId,
      beneficiaryBornDate,
      beneficiaryGender,
      beneficiaryPhone,
      beneficiaryEmail,
      nationalId,
      beneficiaryLastName,
      beneficiaryRelationship,
      beneficiaryBreed,
      beneficiaryColor,
      beneficiaryDocumentType,
      beneficiaryRegionId,
      beneficiaryAddress,
      beneficiaryProvince,
      beneficiaryCounty,
      beneficiaryDistrict
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createResource(shopId: number, name: string, email: string, password: string, timezone: string) {
    let url = `/timekit/resources`;
    let body = {
      shopId,
      name,
      email,
      password,
      timezone,
      action: 'resources'
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createProject(payload: {
    action: string;
    body: {
      name: string;
      slug: string;
      allow_conference: string;
      resources: string[];
      availability: {
        mode: string;
        from: string;
        to: string;
        length: string;
        buffer: string;
        ignore_all_day_events: boolean;
      };
      availability_constraints: Array<{
        allow_day_and_time?: {
          day: string;
          start: string;
          end: string;
        };
      }>;
      booking: {
        graph: string;
        what: string;
        where: string;
        description: string;
      };
      customer_fields?: any;
    };
  }) {
    const url = `/timekit/projects`;
    return this.simplePost(url, JSON.stringify(payload));
  }

  cognitoInstruction(action: string, data: any) {
    const body = {
      action: action,
      ...data
    };
    return this.simplePost('/cognito', JSON.stringify(body));
  }

  discountItemSession(
    shopId: number,
    saleId: number,
    itemId: number,
    clientId: string,
    beneficiaryId: number
  ){
    let url = `/sessions/discount`;
    let body = {
      shopId,
      saleId,
      itemId,
      clientId,
      beneficiaryId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createTimekitResources(
    shopId: number,
    resourceName: string,
    resourceId: string
  ) {
    let url = `/timekit/create`;
    let body = {
      shopId,
      resourceName,
      resourceId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createTimekitProjects(
    shopId: number,
    timekitResourceId: number,
    projectName: string,
    projectId: string,
    categoryId: number,
    subCategoryId: number,
    subSubCategoryId: number,
    where: string,
    externalId: string
  ) {
    let url = `/timekit/projects/create`;
    let body = {
      shopId,
      timekitResourceId,
      projectId,
      projectName,
      categoryId,
      subCategoryId,
      subSubCategoryId,
      where,
      externalId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deleteTimekitProject(projectId: string, shopId: number) {
    let url = `/timekit/projects/delete`;
    let body = {
      shopId,
      projectId,
      action: 'deleteProject'
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateProject(shopId: number, projectId: string, body: any) {
    const url = `timekit/schedule?shopId=${shopId}&projectId=${projectId}`;
    return this.simplePut(url, body);
  }

  // ----- POST METHODS -----

  createProduct(
    productCode: string,
    shopId: number,
    productCategoryId: number,
    productSubCategoryId: number,
    productSubSubCategoryId: number,
    productIndustryId: number,
    productSupplierId: number | any,
    productCollectionId: number | any,
    productTaxId: number,
    productName: string,
    productDescription: string,
    productBaseCost: number,
    productSellPrice: number,
    productDiscountPrice: number,
    productCreationDate: any,
    productStatus: number,
    items: any[],
    variants: any[],
    imgURL: string,
    imgPosition: number,
    imgType: string,
    productType: number,
    productSessions: number,
    productFile: string,
    productPackageItems: any[] = [],
    productConditions: string,
    externalUrl: string | null = null,
    externalRedirectEnabled: boolean = false,
    hidePrice: boolean = false,
    productPaymentMode: number = 1,
    productContribution: number = 0,
    productGracePeriod: number = 0,
    productSessionRenewalPeriod: number = 0,
  ) {
    let url = '/products/create';

    let body = {
      productCode,
      shopId,
      productCategoryId,
      productSubCategoryId,
      productSubSubCategoryId,
      productIndustryId,
      productSupplierId,
      productCollectionId,
      productTaxId,
      productName,
      productDescription,
      productBaseCost,
      productSellPrice,
      productDiscountPrice,
      productCreationDate,
      productStatus,
      items,
      variants,
      imgURL,
      imgPosition,
      imgType,
      productType,
      productSessions,
      productFile,
      productPackageItems,
      productConditions,
      externalUrl,
      externalRedirectEnabled,
      hidePrice,
      productPaymentMode,
      productContribution,
      productGracePeriod,
      productSessionRenewalPeriod
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateProduct(
    productId: number,
    shopId: number,
    description: string,
    active: any,
    items: any[],
    name: string,
    categoryId: number,
    subCategoryId: number,
    subSubCategoryId: number,
    industryId: number,
    supplierId: number | any,
    collectionId: number | any,
    baseCost: number,
    taxId: number,
    sellPrice: number,
    discountPrice: number,
    variants: any[],
    productCreationDate: any,
    deleteItems: any[],
    productType: number,
    productSessions: number,
    productFile: string,
    productIdPackageItems: any[] = [],
    productConditions: string,
    externalUrl: string | null = null,
    externalRedirectEnabled: boolean = false,
    hidePrice: boolean = false,
    productPaymentMode: number = 1,
    productTranslate?: {
      en: {
        productName: { value: string; manual: boolean };
        description: { value: string; manual: boolean };
        conditions: { value: string; manual: boolean };
      }
    },
    productContribution: number = 0,
    productGracePeriod: number = 0,
    productSessionRenewalPeriod: number = 0,
  ) {

    baseCost = parseFloat(baseCost.toString());
    sellPrice = parseFloat(sellPrice.toString());
    discountPrice = parseFloat(discountPrice.toString());

    let url = `/products/${productId}`;
    let body = {
      shopId,
      active,
      description,
      name,
      categoryId,
      subCategoryId,
      subSubCategoryId,
      industryId,
      collectionId,
      supplierId,
      baseCost,
      sellPrice,
      discountPrice,
      taxId,
      items,
      variants,
      deleteItems,
      productCreationDate,
      productType,
      productSessions,
      productFile,
      productIdPackageItems,
      productConditions,
      externalUrl,
      externalRedirectEnabled,
      hidePrice,
      productPaymentMode,
      productTranslate,
      productContribution,
      productGracePeriod,
      productSessionRenewalPeriod
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  createItemImages(payload: any) {
    let url = '/products/images'
    return this.simplePost(url, JSON.stringify(payload))
  }

  deleteItemImages(images: any[]) {
    let url = '/products/images/delete';
    let body = images
    return this.simplePost(url, JSON.stringify(body));
  }

  importClients(shopId: number, customers: any) {
    let url = "/clients/import"
    let body = { shopId, customers }
    return this.simplePost(url, JSON.stringify(body));
  }

  createPaymentMethod(
    shopId: number,
    paymentTypeId: number,
    config: string,
    paymentDescription: string,
    paymentStatus: number
  ) {
    let url = `/payments/create`;
    let body = {
      shopId,
      paymentTypeId,
      config,
      paymentDescription,
      paymentStatus
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deletePayment(shopId: number, paymentTypeId: number) {
    let url = '/payments/delete';
    let body = {
      shopId,
      paymentTypeId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updatePaymentMethod(
    shopId: number,
    paymentTypeId: number,
    config: string,
    paymentDescription: string,
    paymentStatus: number = 1
  ) {
    let url = `/payments/${paymentTypeId}`;
    let body = {
      shopId,
      config,
      paymentDescription,
      paymentStatus
    };
    return this.simplePut(url, JSON.stringify(body));

  }

  createVendor(
    shopId: number,
    firstName: string,
    lastName: string,
    email: string
  ) {
    let url = `vendors/create?shopId=${shopId}`;
    let body = {
      firstName,
      lastName,
      email
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deleteVendor(shopId: number, email: number) {
    let url = `/vendors/delete?shopId=${shopId}`;
    let body = {
      email
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createClient(
    shopId: number,
    firstName: string,
    lastName: string,
    phone: string,
    nationalId: number,
    gender: string,
    email: string,
    username: string,
    isPoolRegister: boolean,
    password: any,
    isVerifiedClient: number,
    documentType: string,
    clientSubscriptionId: number,
    shopCompanyId?: number,
    loginMethod: string = 'PASSWORD',
    bornDate?: string
  ) {
    let url = `/users/register`;
    let body = {
      shopId,
      firstName,
      lastName,
      phone,
      nationalId,
      gender,
      email,
      username,
      isPoolRegister,
      password,
      isVerifiedClient,
      documentType,
      clientSubscriptionId,
      ...(shopCompanyId !== undefined ? { shopCompanyId } : {}),
      loginMethod,
      ...(bornDate ? { bornDate } : {})
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createGiftCardItem(
    giftCardTypeId: number,
    shopId: number,
    amount: number,
    status: number,
    giftCardEmail: string,
    giftCardMessage: string,
    giftCardIsVirtual: number,
  ) {
    let url = `/giftCards/create`;
    let body = {
      giftCardTypeId,
      shopId,
      amount,
      status,
      giftCardEmail,
      giftCardMessage,
      giftCardIsVirtual,
    };

    return this.simplePost(url, JSON.stringify(body))
      .then((result: any) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }

  deleteClient(shopId: number, clientId: number, username: any) {
    let url = '/users/delete';
    let body = {
      shopId,
      clientId,
      username
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  async sendGiftCardEmail(requestBody: { shopId: number; giftCards: { giftCardId: any; }[]; }) {
    return this.simplePost(`/giftCard/sendEmail`, JSON.stringify(requestBody));
  }

  createShopPoint(
    shopId: number,
    shopPointName: string,
    shopPointPhone: string,
    shopPointLocation: string,
    shopPointStatus: number,
    shopPointOnline: number
  ) {
    let url = `/shoppoints/create`;
    let body = {
      shopId,
      shopPointName,
      shopPointPhone,
      shopPointLocation,
      shopPointStatus,
      shopPointOnline
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deleteShopPoint(shopId: number, shopPointId: number) {
    let url = '/shoppoints/delete';
    let body = {
      shopId,
      shopPointId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createCoupon(
    couponId: number,
    shopId: number,
    couponSaleId: number | null,
    couponProductId: number | null,
    couponCategoryId: number | null,
    couponSubCategoryId: number | null,
    couponCode: string | null,
    couponType: string | null,
    couponPriceValue: number,
    couponPercentageValue: number,
    couponMinArticlesQuantity: number | null,
    couponMaxUses: number | null,
    couponDateStart: any,
    couponDateEnd: any,
    couponMinimunCost: number | null,
    couponMaximunDiscount: number,
    couponActive: number,
    couponQuantity: number
  ) {
    let url = `/coupons/create?couponId=${couponId}&shopId=${shopId}&couponSaleId=${couponSaleId}&couponProductId=${couponProductId}&couponCategoryId=${couponCategoryId}&couponSubCategoryId=${couponSubCategoryId}&couponCode=${couponCode}&couponType=${couponType}&couponPriceValue=${couponPriceValue}&couponPercentageValue=${couponPercentageValue}&couponMinArticlesQuantity=${couponMinArticlesQuantity}&couponMaxUses=${couponMaxUses}&couponDateStart=${couponDateStart}&couponDateEnd=${couponDateEnd}&couponMinimunCost=${couponMinimunCost}&couponMaximunDiscount=${couponMaximunDiscount}&couponActive=${couponActive}&couponQuantity=${couponQuantity}`;
    let body = {
      couponId,
      shopId,
      couponSaleId,
      couponProductId,
      couponCategoryId,
      couponSubCategoryId,
      couponCode,
      couponType,
      couponPriceValue,
      couponPercentageValue,
      couponMinArticlesQuantity,
      couponMaxUses,
      couponDateStart,
      couponDateEnd,
      couponMinimunCost,
      couponMaximunDiscount,
      couponActive,
      couponQuantity,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  deleteGiftCardType(shopId: number, giftCardTypeId: number) {
    let url = '/giftCardTypes/delete';
    let body = {
      shopId,
      giftCardTypeId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  createGiftCardType(
    name: string,
    validMonths: number,
    shopId: number,
    amount: string,
    stock: number,
    status: number,
  ) {
    let url = `/giftCardTypes`;
    let body = {
      name,
      validMonths,
      shopId,
      amount,
      stock,
      status,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  // ----- PUT METHODS -----

  updateClient(
    shopId: any,
    clientId: any,
    username: string,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    nationalId: number,
    isPoolRegister: boolean,
    gender: string,
    password: any,
    access: any,
    isVerifiedClient: number,
    documentType: string,
    clientSubscriptionId: number,
    clientRegistrationDate: string,
    shopCompanyId?: number | null,
    loginMethod: string = 'PASSWORD',
    bornDate?: string
  ) {
    let url = `/users/${clientId}`;
    let body = {
      shopId: shopId,
      clientId: clientId,
      username: username,
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      nationalId: nationalId,
      isPoolRegister: isPoolRegister,
      gender: gender,
      password: password,
      access: access,
      isVerifiedClient,
      documentType,
      clientSubscriptionId,
      clientRegistrationDate,
      ...(shopCompanyId !== undefined ? { shopCompanyId } : {}),
      loginMethod,
      ...(bornDate ? { bornDate } : {})
    }
    return this.simplePut(url, JSON.stringify(body));
  }

  async updateSeoSettings(
    shopId: number,
    description: string,
    keywords: string,
    ogTitle: string,
    ogDescription: string,
    ogImageURL: string,
    ogURL: string,
  ) {
    let url = `/seo?shopId=${shopId}`;
    const body = {
      description: description,
      keywords: keywords,
      ogTitle: ogTitle,
      ogDescription: ogDescription,
      ogImageURL: ogImageURL,
      ogURL: ogURL,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  async changeSaleState(
    saleId: number,
    shopId: number,
    saleState: number,
    saleOrderCode: string,
    initialSaleState: string,
    paymentTypeId: number,
    userEmail: string,
    userName: string
  ) {
    let body = {
      saleId: saleId,
      shopId: shopId,
      saleState: saleState,
      saleOrderCode: saleOrderCode,
      initialSaleState: initialSaleState,
      paymentTypeId: paymentTypeId,
      userEmail: userEmail,
      userName: userName
    };
    return this.simplePut(`/sales/${saleId}`, JSON.stringify(body));
  }

  updateShopPoint(
    shopId: number,
    shopPointId: number,
    shopPointName: string,
    shopPointLocation: string,
    shopPointPhone: string,
    shopPointStatus: number,
    shopPointOnline: number
  ) {
    let url = `/shoppoints/${shopPointId}`;
    let body = {
      shopId,
      shopPointId,
      shopPointName,
      shopPointLocation,
      shopPointPhone,
      shopPointStatus,
      shopPointOnline
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  async saveDefaultShopPoint(
    shopId: number,
    shopPointId: number
  ){
    let url = `/shoppoints/default`;
    let body = {
      shopId,
      shopPointId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateShopInfo(
    shopId: number,
    shopName: string,
    shopEmail: string,
    shopCurrencyId: number,
    countryId: number,
    shopGeoLocation1Id: number,
    shopGeoLocation2Id: number,
    shopGeoLocation3Id: number,
    taxId: number,
    shopAddress: string
  ) {
    let url = `/shop/info`;
    let body = {
      shopId,
      shopName,
      shopEmail,
      shopCurrencyId,
      countryId,
      shopGeoLocation1Id,
      shopGeoLocation2Id,
      shopGeoLocation3Id,
      taxId,
      shopAddress,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  updateShopSocialMedia(
    shopId: number,
    socialMediaData: string
  ) {
    let url = `/shop/socialmedia`;
    let body = {
      shopId,
      socialMediaData
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  createShippingCosts(
    shopId: number,
    shippingCosts: number,
    shippingType: string,
  ) {
    let url = `/shippingCosts/create`;
    let body = {
      shopId,
      shippingCosts,
      shippingType
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateShippingCosts(
    Id: number,
    shopId: number,
    shippingCosts: number,
    shippingType: string,
  ) {
    let url = `/shippingCosts/${Id}`;
    let body = {
      Id,
      shopId,
      shippingCosts,
      shippingType
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteShippingCosts(
    shopId: number,
    id: number,
  ) {
    let url = `/shippingCosts/delete`;
    let body = {
      shopId,
      id
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateCoupon(
    couponId: number,
    shopId: number,
    couponSaleId: number | null,
    couponProductId: number | null,
    couponCategoryId: number | null,
    couponSubCategoryId: number | null,
    couponCode: string | null,
    couponType: string | null,
    couponPriceValue: number,
    couponPercentageValue: number,
    couponMinArticlesQuantity: number | null,
    couponMaxUses: number | null,
    couponDateStart: any,
    couponDateEnd: any,
    couponMinimunCost: number | null,
    couponMaximunDiscount: number,
    couponActive: number,
    couponQuantity: number
  ) {
    let url = `/coupons/create?couponId=${couponId}&shopId=${shopId}&couponSaleId=${couponSaleId}&couponProductId=${couponProductId}&couponCategoryId=${couponCategoryId}&couponSubCategoryId=${couponSubCategoryId}&couponCode=${couponCode}&couponType=${couponType}&couponPriceValue=${couponPriceValue}&couponPercentageValue=${couponPercentageValue}&couponMinArticlesQuantity=${couponMinArticlesQuantity}&couponMaxUses=${couponMaxUses}&couponDateStart=${couponDateStart}&couponDateEnd=${couponDateEnd}&couponMinimunCost=${couponMinimunCost}&couponMaximunDiscount=${couponMaximunDiscount}&couponActive=${couponActive}&couponQuantity=${couponQuantity}`;
    let body = {
      couponId,
      shopId,
      couponSaleId,
      couponProductId,
      couponCategoryId,
      couponSubCategoryId,
      couponCode,
      couponType,
      couponPriceValue,
      couponPercentageValue,
      couponMinArticlesQuantity,
      couponMaxUses,
      couponDateStart,
      couponDateEnd,
      couponMinimunCost,
      couponMaximunDiscount,
      couponActive,
      couponQuantity,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateGiftCard(
    giftCardTypeId: number,
    name: string,
    shopId: number,
    amount: string,
    stock: number,
    status: number,
    validMonths: number,
    images: string,
  ) {
    let url = `/giftCardTypes/${giftCardTypeId}`;
    let body = {
      giftCardTypeId,
      name,
      shopId,
      amount,
      stock,
      status,
      validMonths,
      images,
    };
    return this.simplePut(url, JSON.stringify(body));
  }


  //-------------------CATEGORIES------------------

  async getCategories(shopId: number) {
    let url = `/categories?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCategoryById(categoryId: number, shopId: number) {
    let url = `/categories/${categoryId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createCategory(
    categoryIdParent: number,
    shopId: number,
    categoryName: string,
    categoryActiveIcon: string,
    categoryNonActiveIcon: string,
    categoryPosition: number,
    menuCategory: number,
    homeCategory: number,
    categoryDesignType: number,
    categoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/categories/create?shopId=${shopId}`;
    let body = {
      categoryIdParent,
      shopId,
      categoryName,
      categoryActiveIcon,
      categoryNonActiveIcon,
      categoryPosition,
      menuCategory,
      homeCategory,
      categoryDesignType,
      categoryImageUrl,
      isForVerifiedClient
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  deleteCategory(shopId: number, categoryId: number) {
    let url = `/categories/delete?shopId=${shopId}`;
    let body = {
      shopId,
      categoryId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateCategory(
    categoryId: number,
    categoryIdParent: number,
    shopId: number,
    categoryName: string,
    categoryActiveIcon: string,
    categoryNonActiveIcon: string,
    categoryPosition: number,
    menuCategory: number,
    homeCategory: number,
    categoryDesignType: number,
    categoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/categories/${categoryId}?shopId=${shopId}`;
    let body = {
      categoryId,
      categoryIdParent,
      shopId,
      categoryName,
      categoryActiveIcon,
      categoryNonActiveIcon,
      categoryPosition,
      menuCategory,
      homeCategory,
      categoryDesignType,
      categoryImageUrl,
      isForVerifiedClient,
    };
    return this.simplePut(url, JSON.stringify(body));
  }



  //-------------------SUBCATEGORIES------------------

  async getSubCategoryById(subCategoryId: any, shopId: number) {
    let url = `/subCategories/${subCategoryId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getSubCategoryByCategoryId(categoryId: number, shopId: number) {
    let url = `/subCategories/subCategoryList/${categoryId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createSubCategory(
    shopId: number,
    subCategoryName: string,
    subCategoryPosition: number,
    menuSubCategory: number,
    homeSubCategory: number,
    categoryId: number,
    subCategoryDesignType: number,
    subCategoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/subCategories/create?shopId=${shopId}`;
    let body = {
      shopId,
      subCategoryName,
      subCategoryPosition,
      menuSubCategory,
      homeSubCategory,
      categoryId,
      subCategoryDesignType,
      subCategoryImageUrl,
      isForVerifiedClient,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateSubCategory(
    subCategoryId: number,
    shopId: number,
    subCategoryName: string,
    subCategoryPosition: number,
    menuSubCategory: number,
    homeSubCategory: number,
    categoryId: number,
    subCategoryDesignType: number,
    subCategoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/subCategories/${subCategoryId}?shopId=${shopId}`;
    let body = {
      subCategoryId,
      shopId,
      subCategoryName,
      subCategoryPosition,
      menuSubCategory,
      homeSubCategory,
      categoryId,
      subCategoryDesignType,
      subCategoryImageUrl,
      isForVerifiedClient,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteSubCategory(shopId: number, subCategoryId: number) {
    let url = `/subCategories/delete?shopId=${shopId}`;
    let body = {
      subCategoryId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  //-------------------SUBSUBCATEGORIES------------------

  async getSubSubCategoryById(subSubCategoryId: any, shopId: number) {
    let url = `/subSubCategories/${subSubCategoryId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getSubSubCategoryByCategoryId(subCategoryId: number, shopId: number) {
    let url = `/subSubCategories/subSubCategoryList/${subCategoryId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createSubSubCategory(
    shopId: number,
    subSubCategoryName: string,
    subSubCategoryPosition: number,
    menuSubSubCategory: number,
    homeSubSubCategory: number,
    subCategoryId: number,
    subSubCategoryDesignType: number,
    subSubCategoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/subSubCategories/create?shopId=${shopId}`;
    let body = {
      shopId,
      subSubCategoryName,
      subSubCategoryPosition,
      menuSubSubCategory,
      homeSubSubCategory,
      subCategoryId,
      subSubCategoryDesignType,
      subSubCategoryImageUrl,
      isForVerifiedClient,
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  updateSubSubCategory(
    subSubCategoryId: number,
    shopId: number,
    subSubCategoryName: string,
    subSubCategoryPosition: number,
    menuSubSubCategory: number,
    homeSubSubCategory: number,
    subCategoryId: number,
    subSubCategoryDesignType: number,
    subSubCategoryImageUrl: string,
    isForVerifiedClient: number,
  ) {
    let url = `/subSubCategories/${subSubCategoryId}?shopId=${shopId}`;
    let body = {
      subSubCategoryId,
      shopId,
      subSubCategoryName,
      subSubCategoryPosition,
      menuSubSubCategory,
      homeSubSubCategory,
      subCategoryId,
      subSubCategoryDesignType,
      subSubCategoryImageUrl,
      isForVerifiedClient,
    };
    return this.simplePut(url, JSON.stringify(body));
  }


  deleteSubSubCategory(shopId: number, subSubCategoryId: number) {
    let url = `/subSubCategories/delete?shopId=${shopId}`;
    let body = {
      shopId,
      subSubCategoryId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  //-------------------COLLECTIONS------------------
  async getCollections(shopId: number) {
    let url = `/collections?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getCollectionById(idCollection: number, shopId: number) {
    let url = `/collections/${idCollection}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createCollection(
    shopId: number,
    collectionId: number,
    collectionName: string,
    collectionDescription: string,
    isForVerifiedClient: number
  ) {
    let url = `/collections/create?shopId=${shopId}`;
    let body = {
      collectionId,
      collectionName,
      collectionDescription,
      isForVerifiedClient,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateCollection(
    collectionId: number,
    collectionName: string,
    shopId: number,
    collectionDescription: string,
    isForVerifiedClient: number
  ) {
    let url = `/collections/${collectionId}?shopId=${shopId}`;
    let body = {
      collectionId,
      collectionName,
      collectionDescription,
      isForVerifiedClient,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteCollection(shopId: number, collectionId: number) {
    let url = `/collections/delete?shopId=${shopId}`;
    let body = {
      collectionId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }
  //--------------------COMPONENTS------------------
  async getComponents(shopId: number) {
    let url = `/components?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getComponentTypes(shopId: number) {
    let url = `/components/componentType?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getComponentById(idComponent: number, shopId: number) {
    let url = `/components/${idComponent}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createComponent(
    componentId: number,
    shopId: number,
    componentName: string,
    title: string,
    subtitle: string,
    position: number,
    status: number,
    description: string,
    shopContactMail: string,
    componentTypeId: number,
    itemQuantity: number,
    itemListId: number,
    itemSort: number,
    infoImageUrl: string,
    infoDescription: any,
    redirectUrl: string,
    infoTitles: string,
    urlNames: string,
    collectionId: number,
    categoryId: number,
    subCategoryId: number,
    subSubCategoryId: number,
    productComponentType: number,
    infoVideoUrl: string,
    videoUrlType: string,
    pageId: number,
    clientSubscriptionsAllowed: string,
    translatedContent?: string,
    componentConfig?: any

  ): Promise<any> {
    let url = `/components/create?shopId=${shopId}`;
    let body = {
      componentId,
      shopId,
      componentName,
      title,
      subtitle,
      position,
      status,
      description,
      shopContactMail,
      componentTypeId,
      itemQuantity,
      itemListId,
      itemSort,
      infoImageUrl,
      infoDescription,
      redirectUrl,
      infoTitles,
      urlNames,
      collectionId,
      categoryId,
      subCategoryId,
      subSubCategoryId,
      productComponentType,
      infoVideoUrl,
      videoUrlType,
      pageId,
      clientSubscriptionsAllowed,
      translatedContent,
      componentConfig
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateComponentStatusAndPosition(componentDataString: string, shopId: number) {
    let url = `/components?shopId=${shopId}`;
    const requestData = {
      componentData: componentDataString,
      shopId: shopId
    };
    return this.simplePut(url, JSON.stringify(requestData));
  }

  updateComponent(
    componentId: number,
    shopId: number,
    title: string,
    subtitle: string,
    description: string,
    shopContactMail: string,
    itemQuantity: number,
    itemListId: number,
    itemSort: number,
    infoImageUrl: string,
    infoDescription: string,
    redirectUrl: string,
    infoIds: string,
    deleteInfoIds: string,
    infoTitles: string,
    urlNames: string,
    collectionId: number,
    categoryId: number,
    subCategoryId: number,
    subSubCategoryId: number,
    productComponentType: number,
    componentTypeId: number,
    componentName: string,
    infoVideoUrl: string,
    videoUrlType: string,
    pageId: number,
    status: number,
    clientSubscriptionsAllowed: string,
    translatedContent?: string,
    componentConfig?: any
  ) {
    let url = `/components/${componentId}?shopId=${shopId}`;
    const body = {
      componentId,
      shopId,
      title,
      subtitle,
      description,
      shopContactMail,
      itemQuantity,
      itemListId,
      itemSort,
      infoImageUrl,
      infoDescription,
      redirectUrl,
      infoIds,
      deleteInfoIds,
      infoTitles,
      urlNames,
      collectionId,
      categoryId,
      subCategoryId,
      subSubCategoryId,
      productComponentType,
      componentTypeId,
      componentName,
      infoVideoUrl,
      videoUrlType,
      pageId,
      status,
      clientSubscriptionsAllowed,
      translatedContent,
      componentConfig
    };
    return this.simplePut(url, JSON.stringify(body));
  }


  deleteComponent(shopId: number, componentId: number) {
    let url = `/components/delete?shopId=${shopId}`;
    let body = {
      shopId,
      componentId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  //---------------- CLIENT SUBSCRIPTIONS ----------------//


  async getClientSubscriptions(shopId: number) {
    let url = `users/subscriptions?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getClientSubscriptionById(clientSubscriptionId: number, shopId: number) {
    let url = `users/subscriptions/${clientSubscriptionId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async createClientSubscription(
    shopId: number,
    clientSubscriptionName: string
  ) {
    let url = `users/subscriptions?shopId=${shopId}`;
    let body = {
      clientSubscriptionName,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  async updateClientSubscription(
    shopId: number,
    subscriptionId: number,
    subscriptionName: string
  ) {
    let url = `users/subscriptions/${subscriptionId}?shopId=${shopId}`;
    let body = {
      subscriptionId,
      subscriptionName
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  async deleteClientSubscription(shopId: number, subscriptionId: number) {
    let url = `users/subscriptions/delete?shopId=${shopId}`;
    let body = {
      subscriptionId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  //-------------------FREQUENT QUESTIONS------------------

  async getFrequentQuestions(shopId: number) {
    let url = `/frequentQuestions?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createFrequentQuestions(
    shopId: number,
    answer: string,
    question: string
  ) {
    let url = `/frequentQuestions/create?shopId=${shopId}`;
    let body = {
      shopId,
      answer,
      question
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateFrequentQuestions(
    shopId: number,
    faqId: number,
    answer: string,
    question: string,

  ) {
    let url = `/frequentQuestions/${faqId}?shopId=${shopId}`;
    let body = {
      shopId,
      faqId,
      answer,
      question,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteFrequentQuestions(shopId: number, faqId: number) {
    let url = `/frequentQuestions/delete?shopId=${shopId}`;
    let body = {
      shopId,
      faqId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  //-------------------MENU------------------

  async getMenu(shopId: number) {
    let url = `/menu?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  /* ---------- lambda.service.ts ---------- */
  createMenu(shopId: number, menuData: {
    menuId: number;
    menuName: string;
    menuStatus: number;
    menuOptions: any[];
  }) {
    const url = `/menu/create?shopId=${shopId}`;
    return this.simplePost(url, JSON.stringify(menuData));
  }


  updateMenuStatus(status: number, menuId: number, shopId: number) {
    let url = `/menu?shopId=${shopId}`;

    const requestData = {
      shopId: shopId,
      menuId: menuId,
      status: status,
    };
    return this.simplePut(url, JSON.stringify(requestData));
  }

  updateMenuOptionsPositions(updateData: { shopId: number, menuId: number, positions: { [key: number]: number } }) {
    let url = `/menu?shopId=${updateData.shopId}`;
    return this.simplePost(url, JSON.stringify(updateData));
  }


  updateMenu(
    shopId: number,
    menuId: number,
    menuName: string,
    menuStatus: number,
    menuOptions: any[],
    deletedMenuOptionIds: any,
    translatedContent?: any,
  ) {

    let url = `/menu/${menuId}?shopId=${shopId}`;

    const body: any = {
      menuId,
      menuName,
      menuStatus,
      menuOptions,
      deletedMenuOptionIds,
    };
    if (translatedContent) {
      body.translatedContent = translatedContent;
    }
    return this.simplePut(url, JSON.stringify(body));
  }

  async getMenuById(menuId: number, shopId: number) {
    let url = `/menu/${menuId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  deleteMenu(shopId: number, menuId: number) {
    let url = `/menu/delete?shopId=${shopId}`;
    let body = {
      menuId: menuId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  //-------------------PAGES------------------
  async getPages(shopId: number) {
    let url = `/pages?shopId=${shopId}`;
    return this.simpleGet(url);
  }


  createPages(
    shopId: number,
    pageName: string,
    pageUrl: string
  ) {
    let url = `/pages/create?shopId=${shopId}`;
    let body = {
      pageName,
      pageUrl
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updatePages(
    shopId: number,
    pageId: number,
    pageName: string,
    pageUrl: string

  ) {
    let url = `/pages?shopId=${shopId}`;
    let body = {
      shopId,
      pageId,
      pageName,
      pageUrl
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deletePages(
    shopId: number,
    pageId: number
  ) {
    let url = `/pages/delete?shopId=${shopId}`;
    let body = {
      shopId,
      pageId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }


  //-------------------SUBCATEGORIES------------------
  async getSubCategories(shopId: number) {
    let url = `/subCategories?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  //-------------------SUBSUBCATEGORIES------------------

  async getSubSubCategories(shopId: number) {
    let url = `/subSubCategories?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  //-------------------SUPPLIERS------------------


  async getSupplierById(supplierId: number, shopId: number) {
    let url = `/suppliers/${supplierId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createSupplier(
    supplierId: number,
    supplierName: string,
    supplierDescription: string,
    shopId: number,
  ) {
    let url = `/suppliers/create?shopId=${shopId}`;
    let body = {
      supplierId,
      supplierName,
      supplierDescription,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateSupplier(
    supplierId: number,
    supplierName: string,
    shopId: number,
    supplierDescription: string,

  ) {
    let url = `/suppliers/${supplierId}?shopId=${shopId}`;
    let body = {
      supplierId,
      supplierName,
      shopId,
      supplierDescription,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteSupplier(shopId: number, supplierId: number) {
    let url = `/suppliers/delete?shopId=${shopId}`;
    let body = {
      supplierId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  //-------------------THEMING------------------

  async getFonts() {
    let url = `/fonts`;
    return this.simpleGet(url);
  }

  async updateThemingFont(shopId: number, fontFamily: string) {
    let url = `/fonts?shopId=${shopId}`;
    const body = {
      shopId: shopId,
      shopFontFamily2: fontFamily,
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  updateThemingColors(
    shopId: number,
    shopMainColor: string,
    shopSecondaryColor: string,
    shopHeaderColor: string,
    shopMainColorDark: string,
    headerBackground?: any,
    footerBackground?: any
  ) {
    let url = `/theme/color?shopId=${shopId}`;
    let body = {
      shopId,
      shopMainColor,
      shopSecondaryColor,
      shopHeaderColor,
      shopMainColorDark,
      headerBackground,
      footerBackground
    }
    return this.simplePut(url, JSON.stringify(body));
  }

  updateThemingLogo(shopId: number, mainLogo: string, secondaryLogo: string, mobileLogo: string) {
    let url = `/theme/logo?shopId=${shopId}`;
    let body = {
      shopId,
      mainLogo,
      secondaryLogo,
      mobileLogo
    }
    return this.simplePut(url, JSON.stringify(body));
  }

  
  updateThemingHeaderSettings(
    shopId: number,
    showSearchBar: boolean,
    showAuthButtons: boolean,
    showCart: boolean,
    languageSelectorPosition: 'navbar' | 'footer'
  ) {
    let url = `/theme/header?shopId=${shopId}`;
    let body = {
      shopId,
      showSearchBar,
      showAuthButtons,
      showCart,
      languageSelectorPosition
    }
    return this.simplePut(url, JSON.stringify(body));
  }

  // createS3Instance() {
  //   this.s3Instance = new AWS.S3({
  //     accessKeyId: this.ID,
  //     secretAccessKey: this.SECRET,
  //     region: 'us-east-1',
  //   });
  // }

  //-------------------EMAIL TEMPLATE------------------

  async getTemplateData(shopId: number) {
    let url = `/emailTemplate?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createEmailTemplate(shopId: number, body: any) {
    const url = `/emailTemplate?shopId=${shopId}`;
    return this.simplePost(url, JSON.stringify(body));
  }

  //-----  CHECKOUT -----
  upsertCheckoutTemplate(shopId: number, body: { translatedContent?: string; [key: string]: any }) {
    const url = `/checkoutTemplate?shopId=${shopId}`;
    return this.simplePost(url, JSON.stringify(body));
  }

  getCheckoutTemplate(shopId: number) {
    let url = `/checkoutTemplate?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  //Get presigned URL from Lambda to upload file to S3
  async getPresignedUrl(filePath: string, contentType: string, shopId: number): Promise<any> {
    const url = '/s3/presigned-url';
    const body = {
      filePath: filePath,
      contentType: contentType,
      shopId: shopId,
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  //Get presigned URL from Lambda to delete file from S3
  async getDeletePresignedUrl(filePath: string, shopId: number): Promise<any> {
    const url = '/s3/delete';
    const body = {
      filePath: filePath,
      shopId: shopId,
    };

    let config = JSON.parse(this.baseConfig);
    config.method = 'POST';
    config['body'] = JSON.stringify(body);

    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              // If JSON parsing fails and status is 204, resolve with empty object
              if (response.status === 204) {
                resolve({});
              } else {
                reject(error);
              }
            });
        })
        .catch((error) => {
          console.log('getDeletePresignedUrl - fetch failed:', error);
          reject(error);
        });
    });
  }

  //Upload file to S3 using presigned URL from Lambda
  async uploadFile(fileKey: string, file: File, options: any) {
    try {
      //Validate file
      if (!file || file.size === 0) {
        throw new Error('File is empty or invalid');
      }

      //Extract shopId from fileKey (format: shopId/stage/...)
      const shopId = parseInt(fileKey.split('/')[0]);

      //Get presigned URL from Lambda
      const presignedUrlResponse = await this.getPresignedUrl(fileKey, file.type, shopId);

      if (!presignedUrlResponse || !presignedUrlResponse.url) {
        throw new Error('Failed to get presigned URL from Lambda');
      }

      //Upload file to S3 using presigned URL
      const uploadResponse = await fetch(presignedUrlResponse.url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
          'Content-Disposition': 'inline',
        },
      });

      if (!uploadResponse.ok) {
        throw new Error(`S3 upload failed with status ${uploadResponse.status}`);
      }

      //Return the file URL (remove query params from presigned URL)
      const fileUrl = presignedUrlResponse.url.split('?')[0];
      return { imageURL: fileUrl, options: options };
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

  //Upload HTML content to S3 using presigned URL from Lambda
  async uploadHtmlContent(fileKey: string, htmlContent: string, options: any) {
    try {
      if (!htmlContent || htmlContent.trim().length === 0) {
        throw new Error('HTML content is empty');
      }

      //Extract shopId from fileKey (format: shopId/stage/...)
      const shopId = parseInt(fileKey.split('/')[0]);

      //Get presigned URL from Lambda
      const presignedUrlResponse = await this.getPresignedUrl(fileKey, 'text/html; charset=utf-8', shopId);

      if (!presignedUrlResponse || !presignedUrlResponse.url) {
        throw new Error('Failed to get presigned URL from Lambda');
      }

      //Upload HTML content to S3 using presigned URL
      const uploadResponse = await fetch(presignedUrlResponse.url, {
        method: 'PUT',
        body: htmlContent,
        headers: {
          'Content-Type': 'text/html; charset=utf-8',
        },
      });

      if (!uploadResponse.ok) {
        throw new Error(`S3 upload failed with status ${uploadResponse.status}`);
      }

      //Return the file URL (remove query params from presigned URL)
      const fileUrl = presignedUrlResponse.url.split('?')[0];
      return fileUrl;
    } catch (error) {
      console.error('Error uploading HTML content:', error);
      throw error;
    }
  }

  //Delete file from S3 using presigned DELETE URL from Lambda
  async deleteFile(fileKey: string) {
    try {

      if (!fileKey || fileKey.trim().length === 0) {
        throw new Error('File key is empty or invalid');
      }

      //Extract shopId from fileKey (format: shopId/stage/...)
      const shopId = parseInt(fileKey.split('/')[0]);

      //Get presigned DELETE URL from Lambda
      const deleteUrlResponse = await this.getDeletePresignedUrl(fileKey, shopId);

      // If Lambda returns a presigned URL, use it to delete from S3
      if (deleteUrlResponse && deleteUrlResponse.url) {

        //Delete file from S3 using presigned URL
        const deleteResponse = await fetch(deleteUrlResponse.url, {
          method: 'DELETE',
        });

        // S3 returns 204 No Content for successful DELETE operations
        if (!deleteResponse.ok && deleteResponse.status !== 204) {
          throw new Error(`S3 delete failed with status ${deleteResponse.status}`);
        }
      } else {
        // If no URL in response, it means Lambda already deleted it directly (204 response)
      }

      return { success: true };
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  }

  updateLoginRequirement(isLoginRequired: number, shopId: number) {
    const url = `/login/requirement?shopId=${shopId}`;
    const requestData = { shopId, isLoginRequired };
    return this.simplePut(url, JSON.stringify(requestData));
  }

  updatePreferredLanguage(preferredLanguage: number, shopId: number) {
    const url = `/shop/preferredLanguage?shopId=${shopId}`;
    const requestData = { shopId, preferredLanguage };
    return this.simplePut(url, JSON.stringify(requestData));
  }

}

